import type { FunctionComponent, SVGProps } from 'react';

export enum SocialName {
  x = 'x',
  twitter = 'twitter',
  facebook = 'facebook',
  linkedin = 'linkedin',
}

export enum Achievement {
  badge = 'badge',
  room = 'room',
  certificate = 'certificate',
}

export interface CampaignProps {
  utmSource?: string;
  utmCampaign?: string;
}

export interface LinkProps {
  url: string;
  description: string;
  campaign: CampaignProps;
}

export type SocialLinks = {
  [key in SocialName]?: boolean;
};

export interface PageShareProps extends Omit<LinkProps, 'campaign'> {
  socialLinks: SocialLinks;
  campaign?: CampaignProps;
}

export interface SocialIconLinks {
  href: (pageProps: LinkProps) => string;
  icon: FunctionComponent<SVGProps<SVGSVGElement & { title?: string | undefined }>>;
  name: SocialName;
}
